import SendMe from "./sendme";

export default SendMe;